import { render, staticRenderFns } from "./ClearanceDoseMalariaTreatment.vue?vue&type=template&id=119bafcd&"
import script from "./ClearanceDoseMalariaTreatment.vue?vue&type=script&lang=js&"
export * from "./ClearanceDoseMalariaTreatment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports